
class Session {

	constructor(credential, token) {
		this.credential = credential;
		this.token = token;
	}

};

class Credential {

	constructor(email, password) {
		this.email = email;
		this.password = password;
	}

};

class User {

	constructor(id, role, additionalRoles) {
		this.id = id;
		this.role = role;
		this.additionalRoles = additionalRoles;
	}

};

class Token {

	constructor(jsonData) {
		if (jsonData == null || jsonData === undefined)
			jsonData = {};

		this.userId = jsonData.userId;
		this.role = jsonData.role;
		this.token = jsonData.token;
		this.expiration = jsonData.expiration;
		this.additionalRoles = jsonData.additionalRoles;
	}

	getUser() {
		return new User(this.userId, this.role, this.additionalRoles);
	}

}

export { Session, Token, Credential, User };
